import { BallotComparisonChart } from "../../../../content/research/2025-11-17-too-many-ballot-measures/helpers.js";
import * as React from 'react';
export default {
  BallotComparisonChart,
  React
};